<template>
  <div class="main">
    <header>
      <title>{{productInfo.name}} 麦麦酒市</title>
      <!--      <meta name="Keywords" :content=productInfo.name.concat("多少钱,格兰多纳18年怎么样,好不好,洋酒") />-->
      <!--      <meta name="description" :content=productInfo.name+productInfo.subtitle />-->
      <div class="logout" id="logout" v-show="showLogin" @mouseleave="hideLogin" @mouseenter="showLoginMark">
        <li v-show="!token" style="cursor: pointer" @click="toLoginPage">登录</li>
        <li v-show="token" style="cursor: pointer" @click="logout">登出</li>
      </div>
      <div class="top">
        <div class="login" style="border-radius: 0">
          <img @click="toHomePage" style="border-radius: 0; cursor: pointer;" src="../../../static/image/logo.png"
               alt="">
        </div>
        <div class="search">

        </div>
        <div class="login" @mouseleave="hideLogin" @mouseenter="showLoginMark">
          <img :src="avatarUrl" alt="">
          {{displayName}}
        </div>
      </div>
    </header>
    <div class="mark" v-show="isMark" @touchmove.prevent @click="hideMark">
      <div class="mark-code" @touchmove.prevent @click.stop v-show="showCode">
<!--        <p class="p_title">请在麦麦酒市App内设置默认地址后进行购买</p>-->
        <p class="p_title">请在麦麦App内进行购买</p>
        <img src="../../../static/assets/images/5Oi7.png" alt="">
      </div>
      <div class="mark-content" @touchmove.prevent @click.stop v-show="!showCode">
        <p class="p1">
          <span class="span1">购买价格</span>
          <span class="span2">￥{{price}}</span>

        <p class="p1" v-for="(item, index) in fees" :key="index">
          <span class="span1">{{item.name}}</span>
          <span class="span2">￥{{item.value}}</span>
        </p>
        <p class="p3">
          <span class="span1">预计消费</span>
          <span class="span2">￥{{expectPrice}}</span>
        </p>
        <div class="address">
          <div class="address_user">
            <p class="p_user">联系人:{{userAddress.name}}</p>
            <p>{{userAddress.phone}}</p>
          </div>
          <div>
            收货地址:{{userAddress.province}}{{userAddress.city}}{{userAddress.address}}
          </div>
        </div>
        <div class="button" @click="toPay">立即支付</div>
      </div>
    </div>
    <div v-show="productImages.length > 0" class="content">
      <div class="gray-box">
        <div class="gray-box-left">
          <div class="big-img">
            <img :src="bigProductImage"/>
          </div>
          <ul>
            <li style="cursor: pointer" v-for="(item, index) in productImages" :key="index"
                :class="{active: currentIndex == index, activeNo: currentIndex != index}"
                @click="changImage(item.url, index)">
              <img :src="item.url"/>
            </li>
          </ul>
        </div>

        <div class="gray-box-right">
          <p class="title">{{productInfo.name}}</p>
          <p class="subtitle">{{productInfo.subtitle}}</p>
          <p class="subtitle1"><span style="font-size: 18px; padding-top: 0;">数量</span>×1瓶</p>
          <p class="price">{{labelTitle}}：<span v-show="labelPrice">￥</span><span>{{labelPrice}}</span>
          </p>
          <em @click="tobuy">立即购买</em>
        </div>
      </div>
    </div>
    <div v-show="productImages.length > 0" class="htmlImage">
      <div style="width: 650px; margin: 0 auto; border-top: 1px solid #f2f2f2; padding-top: 20px;">
        <el-table
          :data="attributes"
          :show-header="showHeader"
          style="width: 100%">
          <el-table-column
            prop="keyName"
            width="325"
            align="center">
          </el-table-column>
          <el-table-column
            prop="valueName"
            width="325"
            align="center">
          </el-table-column>
        </el-table>
      </div>
      <div class="brandDiv" v-show="productBrandImageUrl || productBrandDescription">
        <img :src="productBrandImageUrl" alt=""/>
        <span v-show="productBrandDescription">品牌故事</span>
        <p>{{productBrandDescription}}</p>
      </div>
      <div class="productDiv" v-show="description">
        <div v-html="description" style="width: 100%;"></div>
      </div>
      <div class="productImageDiv" v-show="productImages != 0">
        <img v-for="(item, index) in productImages" :src="item.url" alt="">
      </div>
      <div class="brandDiv" v-show="productBrandAdditionalUrl">
        <img :src="productBrandAdditionalUrl" alt=""/>
      </div>
      <div class="categoryDiv" v-show="productCategoryImageUrl || productCategoryDescription">
        <img :src="productCategoryImageUrl" alt="">
      </div>
      <div class="serviceDiv" v-show="platformServiceImageUrl">
        <img :src="platformServiceImageUrl" alt="">
      </div>
    </div>
    <ft v-show="productImages.length > 0"></ft>
  </div>
</template>

<script>
  import qs from 'qs';
  import ft from '../../components/common/footer';

  export default {
    name: "productDetailsPage",
    props: ['productId'],
    components: {
      'ft' : ft
    },
    data() {
      return {
        metaInfo: {
          title: 'This is the test',
          meta: [
            {charset: 'utf-8'},
            {
              name: 'viewport',
              content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=yes'
            }
          ]
        },
        showLogin: false,
        token: localStorage.getItem('token'),
        currentIndex: 0,
        isMark: false,
        showHeader: false,
        labelTitle: "",
        labelPrice: "",
        detailObject: {},
        productInfo: {},
        attributes: [],
        productImages: [],
        bigProductImage: "",
        productBrandImageUrl: "",
        productBrandDescription: "",
        description: "",
        productBrandAdditionalUrl: "",
        platformServiceImageUrl: "",
        productCategoryImageUrl: "",
        productCategoryDescription: "",
        orderPreview: {},
        fees: [],
        expectPrice: "",
        price: "",
        userAddress: {},
        showCode: false,
        avatarUrl: "",
        displayName: localStorage.getItem('name')
      }
    },
    metaInfo() {
      return {
        title: this.productInfo.name == null ? this.productInfo.name : this.productInfo.name.replace(/\s*/g,"") + " 麦麦酒市",
        meta: [
          {name: "Keywords", content: this.productInfo.name+"多少钱,"+this.productInfo.name+"怎么样,好不好"},
          {
            name: "description",
            content: this.productInfo.name == null ? this.productInfo.name : this.productInfo.name.replace(/\s*/g,"") +" "+ this.productInfo.subtitle
          },
        ]
      }
    },
    created() {
      this.getData()
    },
    mounted() {
      let logout = document.getElementById('logout');
      logout.style.right = (document.body.clientWidth - 1220) / 2 + 'px';
      this.avatarUrl = localStorage.getItem('avatarUrl') || require('../../../static/image/header.jpg');
    },
    methods: {

      toLoginPage() {
        this.$router.push({
          name: "loginPage"
        })
      },

      logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('name');
        localStorage.removeItem('avatarUrl');
        this.$router.push({
          name: "productPage"
        })
      },

      showLoginMark() {
        this.showLogin = true;
      },

      hideLogin() {
        this.showLogin = false;
      },

      toPay() {
        this.executePaymentWap();
      },

      toHomePage() {
        this.$router.push({
          path: "/"
        })
      },

      executePaymentWap() {
        let obj = {
          bidTypeId: 3,
          biddingPrice: this.expectPrice,
          productId: Number(this.productId),
          orderId: this.orderId,
          paymentTypeId: 3, //pc支付
          isUseCashCoupon: false,
          userAddressId: this.userAddress.id
        };
        console.log(obj)
        this.$store.dispatch('payProductOrder', qs.stringify(obj)).then((res) => {
          if (res.data.code == 200) {
            const div = document.createElement('div');
            div.innerHTML = res.data.data;
            document.body.appendChild(div);
            document.forms[0].submit();
            sessionStorage.removeItem('userCashPage.totalCash');
            sessionStorage.removeItem('userCouponPage.userCouponId');
          } else {
            Toast({
              message: res.data.message,
              position: 'bottom',
              duration: 2000
            })
          }
        }).catch((error) => {
          let obj = {
            message: error.message,
            pageName: this.$route.name
          };
          lazyload.addException(obj);
        })
      },


      tobuy: function () {
        /*if (this.token) {
          this.isMark = true;
        } else {
          this.$router.push({'path': '/login'})
        }*/
        this.showCode = true;
        this.isMark = true;
      },

      hideMark() {
        this.isMark = false;
        document.documentElement.style.overflowY = 'auto';
      },

      getBuyerOrderPreview() {
        let obj = {
          productId: this.productId,
          isUseCashCoupon: false
        };
        this.$store.dispatch('findBuyerOrderPreview', obj).then((res) => {
          this.isMark = true;
          if (res.data.code == 200) {
            this.orderPreview = res.data.data;
            if (this.orderPreview.userAddress == null || this.orderPreview.userAddress == undefined) {
              this.showCode = true;
            } else {
              this.showCode = false;
              document.documentElement.style.overflowY = 'hidden';
              this.fees = this.orderPreview.fees;
              this.price = this.orderPreview.product.lowestAskPrice;
              this.userAddress = this.orderPreview.userAddress;
              let fee = 0;
              this.fees.forEach((item) => {
                if (item.feeTypeId == 2) {
                  fee += Number(this.biddingPrice * parseInt(item.value) / 100);
                } else {
                  fee += Number(item.value);
                }
              });
              this.expectPrice = Number(this.price) + Number(fee);
            }
          }
        })
      }
      ,
      changImage(imageUrl, index) {
        this.bigProductImage = "";
        this.bigProductImage = imageUrl;
        this.currentIndex = index;
      }
      ,
      getData() {
        this.$store.dispatch('findDetailsByProductId', this.productId).then((res) => {
          if (res.data.code == 200) {
            this.detailObject = res.data.data;
            this.description = res.data.data.productInfo.description; //html图文
            this.productInfo = res.data.data.productInfo; //商品详情
            if (this.productInfo.lowestAskPrice) {
              this.labelTitle = "最低出售价格";
              this.labelPrice = this.productInfo.lowestAskPrice;
            } else if (this.productInfo.lastSoldPrice) {
              this.labelTitle = "最近成交价格";
              this.labelPrice = this.productInfo.lastSoldPrice;
            } else if (this.productInfo.retailPrice) {
              this.labelTitle = "市场指导价格";
              this.labelPrice = this.productInfo.retailPrice;
            } else {
              this.labelTitle = "";
              this.labelPrice = "";
            }
            this.productInfo.lowestAskPrice ? this.lowestAskPrice = '￥' + this.productInfo.lowestAskPrice : this.lowestAskPrice = '';
            this.productInfo.highestBidPrice ? this.highestBidPrice = '￥' + this.productInfo.highestBidPrice : this.highestBidPrice = '';
            !this.productInfo.lastSoldPrice ? this.productInfo.lastSoldPrice = '暂无价格' :
              this.productInfo.lastSoldPrice = '￥' + this.productInfo.lastSoldPrice;
            this.productImages = this.detailObject.productImages;//商品图
            this.bigProductImage = this.productImages[0].url;
            this.attributes = this.detailObject.attributes;//特殊属性
            let brandObj = {};
            brandObj.keyName = '品牌';
            brandObj.valueName = this.detailObject.productBrandName;
            this.attributes.unshift(brandObj);
            let originObj = {};
            originObj.keyName = '产地';
            originObj.valueName = this.detailObject.productOriginName;
            this.attributes.unshift(originObj);
            this.relatedProducts = this.detailObject.relatedProducts;//相关商品
            this.productBrandImageUrl = this.detailObject.productBrandImageUrl; //品牌图片
            this.productBrandAdditionalUrl = this.detailObject.productBrandAdditionalUrl; //附属图片
            this.productBrandDescription = this.detailObject.productBrandDescription; //品牌故事
            this.productCategoryImageUrl = this.detailObject.productCategoryImageUrl; //分类图片
            this.productCategoryDescription = this.detailObject.productCategoryDescription; //分类故事
            this.platformServiceImageUrl = this.detailObject.platformServiceImageUrl; //流程图
          } else {
            /*Toast({
              message: res.data.message,
              position: 'bottom',
              duration: 2000
            })*/
          }
        })
      }
      ,
    }
  }
</script>

<style scoped lang="scss">
  .active {
    border: 2px solid #fa7a7a;
  }

  .activeNo {
    border: 1px solid #f2f2f2;
  }

  /deep/ .el-table {
    thead {
      .cell {
        text-align: left; // table 表头 左对齐
      }
    }

    .delete-row {
      color: #d8d8d8;
    }

    .el-table__expand-icon { //修改 el-tabel 折叠按钮的位置
      float: right;
    }

    // 去掉table的border start----------------------------
    border: 0;

    th,
    tr,
    td {
      border: 0;
      background-color: #fff;
    }

    &::before {
      height: 0px;
    }

    &::after {
      width: 0;
    }

    .el-table__fixed:before {
      height: 0;
    }

    // 去掉table的border end----------------------------
  }

  .main {
    width: 100%;

    header {
      width: 100%;
      background: #fff;
      height: 100px;
      position: relative;

      .logout {
        width: 100px;
        height: 50px;
        position: absolute;
        top: 70px;
        border: 1px solid #f2f2f2;
        border-radius: 6px;
        background: #fff;

        li {
          text-align: center;
          line-height: 50px;
        }
      }

      .top {
        height: 100px;
        width: 1220px;
        margin: 0 auto;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .login {
          width: auto;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;

          img {
            display: block;
            width: 50px;
            height: auto;
            border-radius: 50%;
            margin-right: 10px;
          }
        }

        .search {
          width: 700px;
          height: 50px;
          background: #fff;

          input {
            width: 600px;
            outline: none;
            border: none;
            height: 48px;
            font-size: 18px;
          }

          label {
            width: 50px;
            height: 50px;
            display: block;

            img {
              display: block;
              width: 30px;
              height: auto;
              margin: 10px 10px;
            }
          }
        }

        .allCategory {
          margin-top: 20px;
          float: right;
          margin-right: 560px;
        }
      }
    }

    .mark {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1000;
      display: flex;
      justify-content: center;
      align-items: center;

      .mark-code {
        width: 500px;
        background: #fff;
        min-height: 450px;
        padding-top: 20px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-size: 18px;

        img {
          display: block;
          width: 200px;
          height: auto;
          margin-top: 20px;
        }
      }

      .mark-content {
        width: 500px;
        background: #fff;
        min-height: 200px;
        border-radius: 6px;
        padding-top: 30px;
        padding-bottom: 40px;

        .address {
          width: 70%;
          margin: 0 auto;
          font-size: 18px;
          border-top: 5px solid #f2f2f2;
          padding-top: 20px;

          .address_user {
            display: flex;
            justify-content: space-between;
          }
        }

        .p1, .p2 {
          width: 70%;
          font-size: 18px;
          margin-left: 15%;
          display: flex;
          padding: 10px 0;

          span {
            display: block;
          }

          .span1 {
            width: 30%;

          }

          .span2 {
            width: 70%;
            text-align: right;
          }
        }

        .p2 {
          color: #ccc;
        }

        .p3 {
          width: 70%;
          font-size: 18px;
          margin-left: 15%;
          display: flex;
          padding: 30px 0 20px;
          border-top: 1px solid #f2f2f2;
          margin-top: 20px;

          .span1 {
            width: 30%;
          }

          .span2 {
            width: 70%;
            text-align: right;
            font-weight: 500;
            font-size: 26px;
          }
        }

        .button {
          width: 70%;
          margin-left: 15%;
          height: 50px;
          text-align: center;
          line-height: 50px;
          background: #fa7a7a;
          color: #fff;
          margin-top: 50px;
          font-size: 18px;
          cursor: pointer;
        }
      }
    }

    .content {
      width: 1220px;
      min-height: 520px;
      margin: 0 auto;

      .gray-box {
        display: flex;
        padding: 0 60px;
        margin: 20px 0;

        .gray-box-left {
          width: 540px;
          display: flex;
          flex-direction: column;
          align-items: center;

          ul {
            display: flex;

            li {
              width: 80px;
              height: 80px;
              flex-shrink: 0;
              border-radius: 2px;
              margin-left: 10px;
              display: flex;
              justify-content: center;
              align-items: center;

              img {
                height: 80%;
                width: auto;
                display: block;
              }
            }
          }

          .big-img {
            width: 520px;
            margin-left: 20px;
            height: 440px;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              height: 80%;
              width: auto;
              display: block;
            }
          }
        }

        .gray-box-right {
          width: 660px;
          margin-left: 20px;
          display: flex;
          justify-content: center;
          flex-direction: column;

          .title {
            font-size: 24px;
            color: #000;
            font-weight: 500;
          }

          .subtitle {
            font-size: 19px;
            color: #ccc;
            padding: 20px 0;
          }

          .subtitle1 {
            font-size: 19px;
            color: #ccc;
            padding: 0 0 20px;
          }

          .price {
            display: flex;
            align-items: center;
            color: #ccc;
            font-size: 16px;
            padding-bottom: 20px;

            span {
              color: #000;
              font-size: 26px;
            }
          }

          em {
            width: 200px;
            height: 50px;
            display: block;
            text-align: center;
            line-height: 50px;
            background: #fa7a7a;
            color: #fff;
            margin-top: 50px;
            cursor: pointer;
          }
        }
      }
    }

    .htmlImage {
      width: 650px;
      margin: 0 auto;

      .brandDiv {

        img {
          display: block;
          width: 650px;
          height: auto;
          margin: 20px auto;
        }
      }

      .productImageDiv {
        img {
          width: 650px;
          height: auto;
          display: block;
          margin: 20px auto;
        }
      }

      .serviceDiv {
        img {
          width: 650px;
          height: auto;
          display: block;
          margin: 0 auto;
        }
      }

      .categoryDiv {
        img {
          width: 650px;
          height: auto;
          display: block;
          margin: 20px auto;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/product/productDetailsPage.vue